import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#FFF5F3] border-t border-[#EAE3D9] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_sumanya-collection/artifacts/v848dqa8_Sumanya_logo_hd-removebg-preview.png"
              alt="Sumanya — A brand by Suman Jewellers"
              className="h-20 w-auto -ml-2"
            />
            <p className="text-sm text-[#595552] mt-3 leading-relaxed">
              A brand by Suman Jewellers. Heirloom-quality Indian jewellery, hand-crafted with care and rooted in tradition.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="https://www.instagram.com/sumanya.co/" target="_blank" rel="noopener noreferrer" aria-label="Sumanya on Instagram"
                className="h-9 w-9 rounded-full border border-[#C5A059] flex items-center justify-center text-[#8B1E28] hover:bg-white transition-colors" data-testid="social-instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://wa.me/918210981248" target="_blank" rel="noopener noreferrer" aria-label="Chat with Sumanya on WhatsApp"
                className="h-9 w-9 rounded-full border border-[#C5A059] flex items-center justify-center text-[#8B1E28] hover:bg-white transition-colors" data-testid="social-whatsapp">
                <MessageCircle className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="label-small text-[#8A8480] mb-4">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products/rings" className="hover:text-[#8B1E28]">Rings</Link></li>
              <li><Link to="/products/earrings" className="hover:text-[#8B1E28]">Earrings</Link></li>
              <li><Link to="/products/necklaces" className="hover:text-[#8B1E28]">Necklaces</Link></li>
              <li><Link to="/products/bangles" className="hover:text-[#8B1E28]">Bangles</Link></li>
              <li><Link to="/products/mangalsutra" className="hover:text-[#8B1E28]">Mangalsutra</Link></li>
              <li><Link to="/products/silver" className="hover:text-[#8B1E28]">Silver</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="label-small text-[#8A8480] mb-4">Service</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/track-order" className="hover:text-[#8B1E28]" data-testid="footer-track-order">Track Order</Link></li>
              <li><Link to="/shipping-returns" className="hover:text-[#8B1E28]" data-testid="footer-shipping-returns">Shipping &amp; Returns</Link></li>
              <li><Link to="/care-guide" className="hover:text-[#8B1E28]" data-testid="footer-care-guide">Care Guide</Link></li>
              <li><Link to="/terms" className="hover:text-[#8B1E28]" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
              <li><Link to="/about" className="hover:text-[#8B1E28]" data-testid="footer-about">About Sumanya</Link></li>
              <li><Link to="/contact" className="hover:text-[#8B1E28]" data-testid="footer-contact">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="label-small text-[#8A8480] mb-4">Connect</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#C5A059]" /> <a href="mailto:info@sumanya.co" className="hover:text-[#8B1E28]">info@sumanya.co</a></li>
              <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#C5A059]" /> <a href="tel:+918210981248" className="hover:text-[#8B1E28]">+91 8210981248</a></li>
            </ul>
          </div>
        </div>

        <div className="divider-paisley mt-12 mb-6">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
            <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" />
          </svg>
        </div>
        <p className="text-center text-xs text-[#8A8480]" data-testid="footer-copyright">
          © 2026 Sumanya Jewellery. Hand-made in Bharat with love and patience.
        </p>
      </div>
    </footer>
  );
}
